<template>
  <div id="quotations" uk-height-viewport>
    <Header />

    <legend class="uk-legend uk-margin-left uk-margin uk-text-left uk-text-bold">Devis</legend>

    <div class="uk-flex uk-flex-center">
      <div
        class="uk-margin uk-grid-small uk-child-width-auto uk-flex uk-flex-center"
        uk-spinner
        v-show="isLoading"
      ></div>
      <table
        class="uk-table uk-table-small uk-table-divider uk-table-hover uk-margin-left uk-margin-right"
        id="quotationsTable"
        v-show="!isLoading"
      >
        <thead>
          <tr>
            <th class="uk-text-center">
              <p class="uk-text-bold">Nº</p>
            </th>
            <th class="uk-text-center">
              <p class="uk-text-bold">Identité</p>
            </th>
            <th class="uk-text-center">
              <p class="uk-text-bold">Prestation</p>
            </th>
            <th class="uk-text-center">
              <p class="uk-text-bold">Montant</p>
            </th>
            <th class="uk-text-center">
              <p class="uk-text-bold">CP</p>
            </th>
            <th class="uk-text-center">
              <p class="uk-text-bold">Statut</p>
            </th>
            <th class="uk-text-center">
              <p class="uk-text-bold">Communication</p>
            </th>
            <th class="uk-text-center">
              <p class="uk-text-bold">Action</p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(quotation, index) in quotations"
            :key="index"
            v-bind:class="getBackgroundColorForCellAt(index)"
            v-show="shouldDisplayQuotation(quotation)"
          >
            <td class="uk-text-middle uk-text-bold">
              #{{quotation.quotationID}}
              <h6 class="uk-text-muted uk-remove-padding">{{toNumericReadableFormat(quotation.createdAt.toDate())}}</h6>
            </td>
            <td class="uk-text-middle">
              <div class="uk-inline">
                {{quotation.firstName}} {{quotation.lastName}}
                <span
                  class="uk-form-inverted"
                  style="cursor:pointer;"
                  uk-icon="phone"
                ></span>
                <div uk-dropdown="pos: right-center">
                  <ul class="uk-nav uk-dropdown-nav uk-border-rounded">
                    <li>
                      <a href="#">{{quotation.email}}</a>
                    </li>
                    <li>
                      <a href="#">{{quotation.phoneNumber}}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </td>
            <td class="uk-text-middle">
              <p
                v-for="(delivery, deliveryIndex) in quotations[index].deliveries"
                :key="deliveryIndex"
              >· {{getDeliveryTitle(delivery)}}</p>
            </td>

            <td class="uk-text-middle uk-text-bold">{{quotation.amount.toFixed(2)}}€</td>
            <td class="uk-text-middle">{{quotation.address.zipCode}}, {{quotation.address.city}}</td>
            <td class="uk-text-middle">
              <div class="uk-width-auto@m uk-flex-center">
                <div uk-form-custom="target: > * > span:first-child">
                  <select v-model="quotations[index].status" @change="changeStatusQuotation(index)">
                    <option
                      v-bind:value="status.type"
                      v-for="(status, index) in dataStatuses"
                      :key="index"
                    >{{status.title}}</option>
                  </select>
                  <button
                    class="uk-button uk-button-default uk-border-rounded"
                    type="button"
                    tabindex="-1"
                  >
                    <span></span>
                    <span uk-icon="icon: chevron-down"></span>
                  </button>
                </div>
              </div>
            </td>
            <td
              class="uk-text-middle"
            >{{getCSSClassForCommunicationType(quotations[index].communicationType.type)}}</td>
            <td class="uk-text-middle">
              <div class="uk-inline">
                <span
                  class="uk-icon-button uk-background-secondary"
                  style="cursor:pointer;"
                  uk-icon="more"
                ></span>
                <div uk-dropdown="pos: left-center; mode: click">
                  <ul class="uk-nav uk-dropdown-nav">
                    <span
                      class="uk-form-default uk-margin-small-left uk-margin-small-right"
                      style="cursor:pointer;"
                      uk-icon="comment"
                      uk-tooltip="title: Ajouter un commentaire; delay: 500"
                      v-on:click="addComment(quotation)"
                    ></span>
                    <span
                      class="uk-form-default uk-margin-small-left uk-margin-small-right"
                      style="cursor:pointer;"
                      uk-icon="file-pdf"
                      uk-tooltip="title: Consulter; delay: 500"
                      v-on:click="consult(quotation)"
                    ></span>
                    <span
                      v-show="shouldDisplayInvoiceAction(quotation)"
                      v-on:click="pay(quotation)"
                      class="uk-form-success uk-margin-small-left uk-margin-small-right"
                      style="cursor:pointer;"
                      uk-tooltip="title: Régler; delay: 500"
                      uk-icon="credit-card"
                    ></span>
                    <router-link
                      v-show="shouldDisplayInvoiceAction(quotation)"
                      :to="{ path: `create-document/quotations/${quotation.uid}` }"
                    >
                      <span
                        class="uk-form-success uk-margin-small-left uk-margin-small-right"
                        style="cursor:pointer;"
                        uk-tooltip="title: Éditer une facture; delay: 500"
                        uk-icon="file-edit"
                      ></span>
                    </router-link>
                    <span
                      v-show="shouldDisplayDeleteAction(quotation)"
                      class="uk-form-danger uk-margin-small-left uk-margin-small-right"
                      style="cursor:pointer;"
                      uk-icon="trash"
                      v-on:click="deleteQuotation(index)"
                      uk-tooltip="title: Supprimer; delay: 500"
                    ></span>
                  </ul>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import UIkit from "uikit";
import DeliveryType from "../enums/delivery-type";
import Quotation from "../models/quotation";
import Invoice from "../models/invoice";
import QuotationStatus from "../enums/quotation-status";
import CommunicationType from "../enums/communication-type";
import firebase from "firebase";
import Header from "../components/Header";

export default {
  name: "quotation",
  components: {
    Header
  },
  data() {
    return {
      quotations: [],
      dataStatuses: [
        { type: QuotationStatus.TODO, title: "A contacter" },
        { type: QuotationStatus.CONTACTED, title: "Contacté" },
        { type: QuotationStatus.NOT_INTERESTED, title: "Sans suite" },
        { type: QuotationStatus.INVOICED, title: "Facturé" },
        { type: QuotationStatus.DELETED, title: "Supprimé" }
      ],
      isLoading: true,
      searchText: ""
    };
  },

  mounted() {
    const self = this;
    const rawLimit = parseInt(this.$route.params.limit);
    const limit = isNaN(rawLimit) || rawLimit <= 0 ? 100 : rawLimit;
    firebase
      .firestore()
      .collection("Quotations")
      .orderBy("createdAt", "desc")
      .limit(limit)
      .get()
      .then(querySnapshot => {
        self.isLoading = false;
        querySnapshot.forEach(doc => {
          this.quotations.push(new Quotation(doc));
        });
      })
      .catch(function(error) {
        console.log("Error getting documents: ", error);
      });
  },

  methods: {
    addComment: function(quotation) {
      UIkit.modal
        .prompt("Vos commentaires concernant ce devis :", quotation.comment)
        .then(
          comment => {
            if (comment === quotation.comment || comment.empty) return;
            quotation.comment = comment;
            const data = { comment: comment };
            firebase
              .firestore()
              .collection("Quotations")
              .doc(quotation.uid)
              .set(data, { merge: true })
              .then(() => {
                this.displayMessage("Commentaire ajouté.");
              })
              .catch(function(error) {
                console.log("Error getting documents: ", error);
              });
          },
          () => {
            console.log("Comment not added.");
          }
        );
    },

    getDeliveryTitle(delivery) {
      switch (delivery.type) {
        case DeliveryType.CUSTOM:
          return delivery.title;
        case DeliveryType.DELIVERY_ASSISTANCE_COMMON_PART:
          return delivery.title + " de " + delivery.surface + "lots";
        case DeliveryType.SWIMMING_POOL:
          return delivery.surface + " " + delivery.title;
        default:
          return delivery.title + " de " + delivery.surface + "m²";
      }
    },

    getBackgroundColorForCellAt: function(index) {
      const quotation = this.quotations[index];
      switch (quotation.status) {
        case QuotationStatus.TODO:
          return ["uk-background-muted"];
        case QuotationStatus.CONTACTED:
          return [];
        case QuotationStatus.NOT_INTERESTED:
          return [];
        case QuotationStatus.INVOICED:
          return [];
        case QuotationStatus.DELETED:
          return [];
      }
    },

    getCSSClassForCommunicationType: function(type) {
      switch (type) {
        case CommunicationType.RADIO:
          return "Radio";
        case CommunicationType.TV:
          return "TV";
        case CommunicationType.PRESS:
          return "Presse";
        case CommunicationType.INTERNET:
          return "Internet";
        case CommunicationType.FRIEND:
          return "Amis";
        case CommunicationType.OTHER:
          return "Autre";
      }
    },

    deleteQuotation: function(index) {
      if (confirm("Êtes vous sûr(e) de vouloir supprimer ce devis ?")) {
        const self = this;
        var quotation = this.quotations[index];
        quotation.status = QuotationStatus.DELETED;

        firebase
          .firestore()
          .collection("Quotations")
          .doc(quotation.uid)
          .set(quotation.data, { merge: true })
          .then(() => {
            this.quotations.splice(index, 1);
            self.displayMessage("Le devis a bien été supprimé.");
          })
          .catch(function(error) {
            console.log("Error removing documents: ", error);
          });
      }
    },

    changeStatusQuotation: function(index) {
      const self = this;
      const quotation = this.quotations[index];
      firebase
        .firestore()
        .collection("Quotations")
        .doc(quotation.uid)
        .set(quotation.data, { merge: true })
        .then(() => {
          self.displayMessage("Les changements ont bien été enregistré.");
        })
        .catch(function(error) {
          console.log("Error removing documents: ", error);
        });
    },

    toNumericReadableFormat: function(date) {
      var day = date.getDate();
      var monthIndex = date.getMonth() + 1;
      var year = date.getFullYear();
      return "" + day + "/" + monthIndex + "/" + year;
    },

    displayMessage: function(message) {
      UIkit.notification("<span uk-icon='check: warning'></span> " + message, {
        pos: "top-right",
        status: "success"
      });
    },

    shouldDisplayDeleteAction(quotation) {
      return (
        quotation.status === undefined ||
        quotation.status !== QuotationStatus.INVOICED
      );
    },

    shouldDisplayInvoiceAction(quotation) {
      return (
        quotation.status === undefined ||
        quotation.status !== QuotationStatus.INVOICED
      );
    },

    shouldDisplayQuotation(quotation) {
      return (
        quotation.status === undefined ||
        quotation.status !== QuotationStatus.DELETED
      );
    },

    consult: function(document) {
      const storage = firebase.storage().ref();
      var path = document.firebaseStoragePath();

      storage
        .child(path)
        .getDownloadURL()
        .then(function(url) {
          window.open(url, "_blank", "fullscreen=yes");
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    async getDoc(index) {
      return new Promise((resolve, reject) => {
        var storage = firebase.storage().ref();
        storage
          .child("quotations/" + this.getTitle(index) + ".pdf")
          .getDownloadURL()
          .then(function(url) {
            resolve(url);
          })
          .catch(function(error) {
            console.log(error);
            reject(error);
          });
      });
    },

    async open(index) {
      const url = await this.getDoc(index);
      window.open(url, "_blank", "fullscreen=yes");
    },

    async download(index) {
      const url = await this.getDoc(index);
      window.open(url, "_blank", "fullscreen=yes");
    },

    pay: function(document) {
      const url =
        "https://client.checkmy-house.fr/check-quotation/" +
        document.quotationID;
      window.open(url, "_blank", "fullscreen=yes");
    },

    getTitle(document) {
      var title =
        document instanceof Invoice
          ? "Facture-" + document.invoiceID
          : "Devis-" + document.quotationID;
      return title;
    }
  }
};
</script>

<style scoped>
table tbody tr:hover {
  background-color: rgba(48, 158, 181, 0.05);
}
.uk-background-secondary {
  background-color: rgba(48, 158, 181, 0.05);
}
</style>